export enum HsaClassificationDecidedBy {
  Agent = "agent",
  Admin = "admin",
}
